import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import PortfolioProject from './pages/PortfolioProject';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import AutomotiveConsulting from './pages/AutomotiveConsulting';
import AdminDashboard from './pages/admin/Dashboard';
import AdminBlog from './pages/admin/Blog';
import AdminPortfolio from './pages/admin/Portfolio';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import { BlogProvider } from './context/BlogContext';
import { PortfolioProvider } from './context/PortfolioContext';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BlogProvider>
          <PortfolioProvider>
            <Router>
              <Toaster position="top-right" />
              <Routes>
                <Route path="/conseil-auto" element={<AutomotiveConsulting />} />
                <Route path="/" element={<Layout />}>
                  <Route index element={<Home />} />
                  <Route path="about" element={<About />} />
                  <Route path="portfolio" element={<Portfolio />} />
                  <Route path="portfolio/:slug" element={<PortfolioProject />} />
                  <Route path="blog" element={<Blog />} />
                  <Route path="blog/:slug" element={<BlogPost />} />
                  <Route path="contact" element={<Contact />} />
                  <Route 
                    path="admin" 
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route 
                    path="admin/blog" 
                    element={
                      <ProtectedRoute>
                        <AdminBlog />
                      </ProtectedRoute>
                    }
                  />
                  <Route 
                    path="admin/portfolio" 
                    element={
                      <ProtectedRoute>
                        <AdminPortfolio />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<NotFound />} />
                </Route>
                <Route path="/login" element={<Login />} />
              </Routes>
            </Router>
          </PortfolioProvider>
        </BlogProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
